import "./StepList.css";

export default function StepList({
  items = [],
  children,
  numbers,
  className = "",
}) {
  return (
    <div className={`ui-step-list ${className}`}>
      {items.map((item, index) => {
        const number = numbers?.[index] ?? index + 1;
        const title = typeof item === "string" ? item : item.title;
        const description = typeof item === "object" ? item.description || item.desc : "";

        return (
          <div className="ui-step-item" key={`${title}-${index}`}>
            <span className="ui-step-number">{number}</span>
            <div className="ui-step-content">
              {title && <div className="ui-step-title">{title}</div>}
              {description && <div className="ui-step-description">{description}</div>}
            </div>
          </div>
        );
      })}

      {children}
    </div>
  );
}
